import { render, staticRenderFns } from "./publicPrice.vue?vue&type=template&id=78d7dc3a&scoped=true&"
var script = {}
import style0 from "./publicPrice.vue?vue&type=style&index=0&id=78d7dc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7dc3a",
  null
  
)

export default component.exports